var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center justify-center"},[_c('VueQRCodeComponent',{staticClass:"inline-block mr-32 mt-24",attrs:{"text":decodeURIComponent(_vm.$route.params.url),"size":_vm.$route.params.size,"color":decodeURIComponent(_vm.$route.params.color),"bg-color":decodeURIComponent(_vm.$route.params.bgColor),"error-level":_vm.errorLevel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }